module.exports = __webpack_public_path__ + "static/about_sec2-287c84b60d2e074197d492910a3557f6.png";